import React, { useEffect, useState } from "react";
import { HelpDrawerToggle } from "@cmsgov/ds-medicare-gov";
import { sendTealiumEvent, useTranslate } from "../../../helpers";
import LearnAboutTiers from "./LearnAboutTiers";
import {
  AbstractBenefits,
  PharmacyPreferencesAndFrequencies,
} from "../../../@types";
import { dropdownTranslations, filterOptions } from "./AbstractBenefitsHelpers";
import AbstractBenefitsTableContainer from "./AbstractBenefitsTableContainer";

export const AbstractBenefitsTableList: React.FunctionComponent<{
  abstractBenefits: AbstractBenefits;
}> = ({ abstractBenefits }) => {
  const t = useTranslate();
  const [showDrugTierHelp, setShowDrugTierHelp] = useState<boolean>(false);
  const [filteredOptions, setFilteredOptions] = useState<
    Array<PharmacyPreferencesAndFrequencies>
  >([]);

  useEffect(() => {
    setFilteredOptions(filterOptions(abstractBenefits));
  }, [abstractBenefits]);

  return filteredOptions.length > 0 ? (
    <div
      id={t("abstract_benefits.title")
        .replace(/\W/g, "-")
        .toLowerCase()}
      className="the-abstract-table-section"
    >
      <div className="AbstractBenefits__infoBox ds-u-padding--2">
        <p>{t("abstract_benefits.info")}</p>
        <HelpDrawerToggle
          helpDrawerOpen={showDrugTierHelp}
          showDrawer={(): void => {
            setShowDrugTierHelp(true);
            sendTealiumEvent("Help Drawer", "Learn About Tiers");
          }}
        >
          {t("plan_terms.learn_about_tiers")}
        </HelpDrawerToggle>
      </div>

      {filteredOptions.length > 0
        ? filteredOptions.map((prefAndFreq: string) => {
            return (
              <div
                className="AbstractBenefitsTableList"
                key={PharmacyPreferencesAndFrequencies[prefAndFreq]}
              >
                <h3 className="ds-u-margin-bottom--2">
                  {t(dropdownTranslations[prefAndFreq])}
                </h3>
                <AbstractBenefitsTableContainer
                  pharmacyPreference={
                    prefAndFreq as PharmacyPreferencesAndFrequencies
                  }
                  abstractBenefits={abstractBenefits}
                />
                <div className="ds-u-margin-y--6">
                  <hr />
                </div>
              </div>
            );
          })
        : null}

      {showDrugTierHelp && (
        <LearnAboutTiers
          onSetShowDrugTierHelp={(show: boolean): void =>
            setShowDrugTierHelp(show)
          }
        />
      )}
    </div>
  ) : null;
};

export default AbstractBenefitsTableList;
